<ems-table-record-count class="tbl-rec-count" [showRecords]="tableCountData?.paginationCount && tableCountData?.paginationCount > 15" [count]="tableCountData.totalRecords" [showTotalForInstrumentGrps]="tableCountData.totalRecords"
                        (emitter)="receiveDataFromChild($event);paginator.changePage(0);"></ems-table-record-count>

<ems-view-history #viewHistory [historyId]="masterGrpHistoryRecord.historyId" [getOrgId]="0"
  [ruleSubType]="masterGrpHistoryRecord.masterGrpSubType" [historyTitle]="masterGrpHistoryRecord.masterGrpName"
  [historyData]="masterGrpHistoryRecord.masterGrpHistory" [totalElements]="masterGrpHistoryRecord.historyRecords"
  (paginateHistoryList)="getHistoryPagination(masterGrpHistoryRecord.historyId, $event)"></ems-view-history>

<form [formGroup]="masterGroupForm">
  <p-table [columns]="masterGroupsTableCol" [value]="masterAcctList" [(selection)]="selectedArr" [customSort]="true" dataKey="id" [lazy]="true"
  (onRowSelect)="onRowSelect($event)"
  (onRowUnselect)="onRowUnselect($event)"
  (onHeaderCheckboxToggle)="onSelectAllChange($event)"
  (selectionChange)="onSelectionChange()"
  metaKeySelection="true" (onLazyLoad)="customSort($event)" [multiSortMeta]="multiSortMeta" sortMode="multiple" #empGrps class="common-data-table manage-client-list-table">
  <ng-template #sorticon pTemplate="sorticon" let-sortOrder>
    <span class="pi" [ngClass]="{
          'pi-sort': sortOrder === 0,
          'pi-caret-down': sortOrder === -1,
          'pi-caret-up': sortOrder === 1,
        }"></span>
  </ng-template>

  <ng-template pTemplate="header" let-columns>
    <!-- Column header section -->
    <tr class="filter-header-input">
      <th class="table-checkbox-selection filter-icon" aria-label="Filter toggle">
        <span class="sr-only">Filter toggle</span>
        <button type="button" class="btn-icon-only cursor" (click)="toggleFunction()" aria-label="Toggle filter" [attr.aria-expanded]="toggle">
          <em class="pi pi-filter" aria-hidden="true"></em>
        </button>
      </th>
      <th class="table-checkbox-selection" *ngIf="showMGPSelection" aria-label="Selection">
        <span class="sr-only">Selection</span>
        <p-tableHeaderCheckbox *ngIf="this.assignformData?.ruleSubCategory !== this.getSharedConstant.openBrokerage.subType" class="emtr-checkbox sdps-p-right_x-small" [disabled]="toCheckOBPGroup()" ></p-tableHeaderCheckbox>
      </th>
      <ng-container *ngFor="let col of columns">
        <th scope="col" class="word-break" [pSortableColumn]="col.field" *ngIf="showActionBtn ? (col.field !== 'actions' || (col.field === 'actions' && toggle)) : col.field === 'actions' || col.field === 'noOfSubAccounts' || col.field === 'noOfRules' || col.field==='updTs' || col.field === 'name' || col.field === 'description'"
          [pSortableColumnDisabled]="(col.field === 'noOfRules' || col.field === 'noOfSubAccounts' || col.field === 'actions')"
          [ngClass]="[ col.header === 'Name' || col.header === 'Description' ? 'w-20-per':'' , col.header === 'Last Updated' || col.header === 'No. of Accounts' || col.header === 'No. of Rules Assigned' ? 'w-15-per':'', (tableCountData.paginationCount && tableCountData.paginationCount > 1 || filterClicked) ? 'pointer-events-auto':'pointer-events-none']"
          [attr.aria-label]="(showActionBtn && col.field === 'actions' && toggle) ? 'Actions' : (col.header || 'Column')">
          {{ !(showActionBtn && col.field === 'actions' && toggle) ? (col.header || 'Column') : ''}}
          <span class="sr-only" *ngIf="showActionBtn && col.field === 'actions' && toggle">Actions</span>
          <p-sortIcon [field]="col.field"
            *ngIf="(col.field !== 'noOfSubAccounts' && col.field !== 'noOfRules' && col.field !== 'actions') && (tableCountData.paginationCount && tableCountData.paginationCount > 1 || filterClicked) "></p-sortIcon>
        </th>
      </ng-container>
    </tr>
    <tr *ngIf="toggle" class="filtered-row-input">
      <th aria-label="Filter toggle"><span class="sr-only">Filter toggle</span></th>
      <th *ngIf="showMGPSelection" aria-label="Selection"><span class="sr-only">Selection</span></th>

    <th class="sdps-p-left_small" *ngFor="let col of columns ;let i = index;" [attr.aria-label]="(col.header || 'Column') + ' filter'">
      <span class="sr-only">{{ (col.header || 'Column') + ' filter' }}</span>
      <input pInputText [attr.aria-label]="col.header + ' filter'" formControlName="groupName" class="w-100-per" type="text" name="name" id="masterGroupNameInput" [maxLength]="35" [ngClass]="{'invalidField': (filterBtnDisableForName || masterGroupForm.get('groupName').invalid) }"
     emsStartSpaceValidator *ngIf="col.field === 'name'" (keydown.enter)="!( masterGroupForm.invalid || filterBtnDisableForName) ? applyFilter(): ''" onkeydown="return (event.keyCode !== 13);">
      <input pInputText [attr.aria-label]="col.header + ' filter'" formControlName="groupDescription" class="w-100-per" type="text" name="description" id="masterGroupDescription" [maxLength]="35"
      *ngIf="col.field === 'description'" (keydown.enter)="!( masterGroupForm.invalid || filterBtnDisableForName)? applyFilter(): ''" onkeydown="return (event.keyCode !== 13);"
      emsStartSpaceValidator [ngClass]="{'invalidField': masterGroupForm.get('groupDescription').invalid }">
      <div *ngIf="col.field === 'updTs'">
        <ems-date-range-filter #range (submittedDate)="getSelectedDate($event);"></ems-date-range-filter>
      </div>
      <div *ngIf="col.field === 'actions'" class="w-200-px">
        <button class="buttons button-filter" [disabled]="!masterGroupForm.dirty && !isSortingChanged"
          [attr.aria-label]="getSharedConstant.filterButton.clearAllButton || 'Clear all filters'"
          [innerHTML]="getSharedConstant.filterButton.clearAllButton"
          (click)="filterClicked? clickedClearButton(isSortingChanged) : resetForm(isSortingChanged); clearSuccessAndErrorMessages();"></button>
        <button class="buttons button-save button-filter" (click)="applyFilter()"
          [disabled]="filterBtnDisableForName || masterGroupForm.invalid"
          [attr.aria-label]="getSharedConstant.filterButton.applyFilterButton || 'Apply filter'"
          [innerHTML]="getSharedConstant.filterButton.applyFilterButton"></button>
      </div>
    </th>
    </tr>

    <tr *ngIf="!showMGPSelection && toggle && showActionItems" class="filter-row-input">
      <th aria-label="Sub-header toggle"><span class="sr-only">Sub-header toggle</span></th>
      <th *ngFor="let col of groupSubHeader" [attr.aria-label]="col.header || 'Column'">
        {{col.header || 'Column'}}
      </th>
    </tr>

    <tr *ngIf="!showMGPSelection && toggle && showActionItems" class="filtered-row-input">
      <th aria-label="Records control"><span class="sr-only">Records control</span></th>
      <th class="sdps-p-left_small" *ngFor="let col of groupSubHeader" [attr.aria-label]="(col.header || 'Control')">
        <span class="sr-only">{{ col.header || 'Control' }}</span>
        <div class="timePickerForm sdps-p-bottom_medium" *ngIf="col.field === 'showRecords'">
          <p-select inputId="masterGrpShowRecords" aria-label="Records per page" class="request-list-header-dropdown" optionLabel="label" formControlName="{{col.field}}" [options]="getSharedConstant.showRecords">
          </p-select>
          <!-- editableTimepicker -->
        </div>
      </th>
    </tr>
  </ng-template>

    <ng-template pTemplate="emptymessage" let-columns>
      <tr>
        <td [attr.colspan]="columns.length + 3" class="sdps-text-center sdps-font-weight-bold"
            [innerHTML]="getSharedConstant.noRecords"></td>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-rowData let-columns="columns">
      <tr>
        <td class="table-checkbox-selection filter-icon"></td>
        <td *ngIf="showMGPSelection">
        <p-tableCheckbox class="emtr-checkbox sdps-p-right_x-small" [value]="rowData" [checked]="defaultMasterGrpSelectedForOBP()" [ngClass]="{'p-disabled': toCheckOBPGroup()}"></p-tableCheckbox>
        </td>
        <ng-container *ngFor="let col of columns">
          <td *ngIf="col.field !== 'actions'">
          <span
            *ngIf="col.field !== 'updTs' && col.field !== 'noOfRules' && col.field !== 'name' && col.field !== 'noOfEmployees' && col.field !== 'noOfSubAccounts'"
            [innerHTML]='rowData[col.field]'></span>
            <span *ngIf="col.field ==='noOfSubAccounts' && rowData.assignStatus !== 'Failed'" [innerHTML]='(processID.indexOf(rowData.id) !== -1) ? ((showUpdatedCount && showUpdatedCount.data.noOfSubAccounts) ? showUpdatedCount.data.noOfSubAccounts : " ") : rowData[col.field]'></span>
            <span *ngIf="col.field ==='noOfRules' && rowData.assignStatus !== 'Failed'" [innerHTML]='(processID.indexOf(rowData.id) !== -1) ? ((showUpdatedCount && showUpdatedCount.data.noOfRules) ? showUpdatedCount.data.noOfRules : " ") : rowData[col.field]'></span>

            <div *ngIf="showActionBtn ? !showActionBtn : col.field ==='noOfRules' || col.field ==='noOfSubAccounts'">
              <span *ngIf="processID.indexOf(rowData.id) !== -1  && showSpinnerFlag[rowData.id]"><p-progressSpinner class="spinnerStyle"></p-progressSpinner></span>
              <span *ngIf="processID.indexOf(rowData.id) !== -1  && showErrorFlag[rowData.id]">{{rowData[col.field]}} <em class="sch-exclamation-octagon" aria-hidden="true" pTooltip="{{getSharedConstant[getSharedConstant.manageMasterGroups.groupTypeMGP].toolTipMsgexclamatoryIcon}}"
                                                                                                                          tooltipPosition="left"></em></span>
              <span *ngIf="rowData.assignStatus === 'Failed'">{{rowData[col.field]}} <em class="sch-exclamation-octagon" aria-hidden="true" [pTooltip]="getSharedConstant[getSharedConstant.manageMasterGroups.groupTypeMGP].toolTipMsgexclamatoryIcon"
                                                                                         tooltipPosition="left"></em></span>
            </div>

            <span *ngIf="col.field==='updTs'"
                  [innerHTML]="(rowData[col.field]) ? moment(rowData[col.field]).format('MM/DD/YYYY') : ''"></span>
            <span *ngIf="col.field==='name'&& !showMGPSelection" [id]="'masterAccGrpLink_' + rowData['id']" [ngClass]="{'masterAccGrpLinks cursor': rowData['type'] !== 'ORG'}"
                  (click)="editMasterGrp(rowData)" [innerHTML]='rowData[col.field]'></span>
            <span *ngIf="col.field==='name' && showMGPSelection" [id]="'masterAccGrpName_' + rowData['id']" [innerHTML]='rowData[col.field]'></span>
          </td>
          <td *ngIf="showMGPSelection && showActionBtn && col.field === 'actions' && toggle"></td>
        </ng-container>
        <td *ngIf="!showMGPSelection">
          <div class="action-menu-dropdown" *ngIf="rowData['type'] !== 'ORG'">
            <button type="button" class="cursor sdps-p-around_xx-small"
                    [attr.aria-label]="'Actions for ' + rowData['name']"
                    aria-haspopup="menu"
                    [attr.aria-expanded]="empId===rowData['id']"
                    (click)="showActionMenu=true; empId=rowData['id']; formData(rowData);"
                    (keydown)="onActionButtonKeydown($event, rowData)"
                    [ngClass]="{'active-menu':(empId===rowData['id'])}">
              <em class="pi pi-ellipsis-h sdps-p-around_xx-small" aria-hidden="true"></em>
            </button>
            <p-menu [model]="actionMenu" *ngIf="empId===rowData['id']" class="menu-dropdown"></p-menu>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
</form>
<p-paginator class="common-pagination" [rows]="this.param.pageSize" [alwaysShow]="tableCountData?.paginationCount && tableCountData?.paginationCount > 15 ? true : false"
[totalRecords]="tableCountData.paginationCount" (onPageChange)="paginate($event)" #p></p-paginator>
